<template>
  <v-container>
    <FullscreenDialog
      title="Welcome"
      v-model="schoolAdded"
      content-class="custom-dialogue"
    >
      <template slot="content">
        <v-container class="mb-12 px-6">
          <v-row>
            <v-col style="margin-bottom: 116px">
              <h1>
                {{ $t("schoolSetup.complete.title") }}
              </h1>
              <p v-html="completedDescription()" />
              <p class="subtitle-1 ads-blue-2 mt-8 mb-2">
                {{ $t("schoolSetup.complete.schoolHeading") }}
              </p>
              <v-list>
                <v-list-item
                  v-for="school in mySchools"
                  :key="school.schoolId"
                  class="px-0"
                >
                  <v-list-item-avatar>
                    <div
                      class="school-logo"
                      :style="`border-color: ${school.details.colour}`"
                    >
                      <v-img
                        :src="school.details.logo"
                        height="26"
                        width="26"
                        contain
                        class="flex-shrink-0 flex-grow-0"
                      />
                    </div>
                  </v-list-item-avatar>

                  <v-list-item-content>
                    <v-list-item-title v-text="school.details.name" />
                  </v-list-item-content>

                  <v-list-item-action>
                    <v-icon class="ads-success-green">
                      mdi-check-circle
                    </v-icon>
                  </v-list-item-action>
                </v-list-item>
              </v-list>
              <div class="school-buttons">
                <AdsButton
                  :button-text="$t('schoolSetup.complete.addAnotherSchool')"
                  :secondary="true"
                  block
                  class="mb-3"
                  @click="schoolAdded = false"
                />
                <AdsButton
                  :button-text="
                    news.initial
                      ? $t('schoolSetup.complete.finish')
                      : $t('schoolSetup.complete.loading')
                  "
                  color="error"
                  block
                  :disabled="!news.initial"
                  @click="$router.push(`/`)"
                />
              </div>
            </v-col>
          </v-row>
        </v-container>
      </template>
    </FullscreenDialog>
    <FullscreenDialog
      title=""
      v-model="openNewsDetail"
    >
      <template slot="content">
        <NewsInfo
          :news-item="newsObj"
          :school-images="schoolsLogo"
        />
      </template>
      <template slot="action">
        <v-btn
          icon
          color="white"
          @click="externalLink(newsObj.url)"
        >
          <v-icon>mdi-earth</v-icon>
        </v-btn>
        <v-btn
          icon
          color="white"
          @click="openShareSheet(newsObj.url, newsObj.title)"
        >
          <v-icon>mdi-share-variant-outline</v-icon>
        </v-btn>
      </template>
    </FullscreenDialog>
    <Alert
      :show-alert="error"
      type="error"
      :text="$t('schoolSetup.error.title')"
      :subtext="$t('schoolSetup.error.subtitle')"
      :timeout="3000"
      position="Bottom"
      @input="onclose"
    />
    <v-row>
      <v-col>
        <template>
          <h1>
            {{ $t("schoolSetup.addSchool.title") }}
          </h1>
          <p>
            {{ $t("schoolSetup.addSchool.description") }}
          </p>
          <v-autocomplete
            v-model="school"
            :items="filteredSchools"
            :placeholder="$t('schoolSetup.addSchool.placeholder')"
            prepend-inner-icon="mdi-magnify"
            :clearable="true"
            item-text="name"
            :menu-props="{ maxHeight: 200 }"
            return-object
            :autofocus="true"
            :search-input.sync="inputText"
            :no-data-text="filter()"
          />
          <div class="school-buttons">
            <AdsButton
              button-text="Continue"
              :secondary="true"
              block
              v-if="mySchools.length > 0"
              class="mb-3"
              @click="schoolAdded = true"
            />
          </div>
        </template>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import { FullscreenDialog, AdsButton, Alert } from "@nswdoe/doe-ui-core";
import NewsInfo from "../components/NewsInfo";
import { mapGetters } from "vuex";

import {
  FA_SCREEN_CLASS,
  FA_SCREEN_NAME,
  FA_SCREEN_VIEW
} from "@/settings/constants";
const SchoolSetup = {
  computed: {
    ...mapGetters({
      appID: "appID",
      allSchools: "schools",
      mySchools: "mySchools",
      news: "news",
      article: "article",
      schoolsLogo: "schoolsLogo"
    }),
    filteredSchools: function() {
      let res = [];
      res = this.allSchools.filter(el => {
        return !this.mySchools.find(element => {
          return element.schoolCode == el.code;
        });
      });
      return this.inputText ? res : [];
    }
  },
  components: {
    FullscreenDialog,
    AdsButton,
    Alert,
    NewsInfo
  },
  name: "SchoolSetup",
  title: "Welcome",
  created: function() {
    //eslint-disable-next-line
    NativeJS.debugLog("test debug on school setup load");
    if (!this.$store.getters.appID) {
      this.$store.dispatch("setAppID");
      this.$store.dispatch("registerApp");
    }

    if (this.$route.params.id) {
      this.$store
        .dispatch("getIndividualNews", this.$route.params.id)
        .then(() => {
          this.showNewsDetails(this.article);
        });
    } else {
      this.analytics(FA_SCREEN_VIEW, {
        [FA_SCREEN_CLASS]: "my_schools",
        [FA_SCREEN_NAME]: "school_list"
      });
    }
  },
  data() {
    return {
      school: null,
      schoolAdded: false,
      selectedSchools: [],
      error: false,
      inputText: null,
      openNewsDetail: false,
      newsObj: {}
    };
  },
  methods: {
    onclose: function() {
      this.error = false;
    },
    filter: function() {
      if (
        this.inputText &&
        this.mySchools.filter(e =>
          e.details.name.toLowerCase().includes(this.inputText.toLowerCase())
        ).length > 0
      ) {
        return this.$t("schoolSetup.error.alreadyAdded");
      } else if (this.inputText) {
        return this.$t("schoolSetup.error.noSchool");
      } else {
        return this.$t("schoolSetup.addSchool.placeholder");
      }
    },
    showNewsDetails(newsItem) {
      this.$store.dispatch("setArticleRead", newsItem.id);
      this.openNewsDetail = true;
      this.newsObj = newsItem;
    },
    completedDescription: function() {
      return this.$t("schoolSetup.complete.description");
    }
  },
  watch: {
    school: function() {
      if (this.school) {
        this.$store
          .dispatch("selectSchool", this.school.code)
          .then(() => {
            this.schoolAdded = true;
            this.school = null;
            this.analytics(FA_SCREEN_VIEW, {
              [FA_SCREEN_CLASS]: "my_schools",
              [FA_SCREEN_NAME]: "add_school_complete"
            });
          })
          .catch(() => {
            this.error = true;
          });
      }
    }
  }
};
export default SchoolSetup;
</script>
<style lang="scss" scoped>
h1 {
  font-size: 1.875rem;
  line-height: 2.25rem;
  margin-bottom: 1rem;
}
p {
  font-size: 1.125rem;
}
.subtitle-1 {
  font-size: 1.125rem !important;
  font-weight: 500 !important;
}
.school-buttons {
  position: fixed;
  right: 0;
  bottom: 0;
  left: 0;
  padding: 24px;
  background-color: white;
}
.toolbar::v-deep .headingMobile {
  margin-left: 0;
}
div::v-deep {
  .v-snack.v-snack--bottom {
    left: 0;
  }
  .v-snack__action {
    margin-right: 0;
  }
  button {
    margin-top: -4px;
    margin-right: -6px;
  }
}
.school-logo {
  height: 40px;
  width: 40px;
  padding: 5px;
  border: 2px solid;
  border-radius: 100px;
}
.v-autocomplete__content {
  .v-list::v-deep {
    .v-list-item__title {
      color: #407ec9;
      font-weight: 500;
    }
  }
}
</style>
